import { useEffect, useState } from 'react'
import {
  Accordion,
  Anchor,
  Button,
  H2,
  Paragraph,
  Separator,
  Spinner,
  XStack,
  YStack,
  useWindowDimensions,
} from '@my/ui'
import { color, TZAApiClient, useAuthedRequestFn, useLink } from '@my/util'
import { useQuery } from '@tanstack/react-query'
import { useUser } from '@clerk/react'
import { AccordionTrigger } from '../financial-profile/helpers/Helper'
import { Copy, CopyCheck } from '@tamagui/lucide-icons-2'

export function InternalAdmin() {
  const { height, width } = useWindowDimensions()
  const { user } = useUser()
  //const link = useLink('/')
  const authedRequestFn = useAuthedRequestFn()
  /* const reviewDataQuery = useQuery({ 
        queryKey: ['financial-review'], 
        queryFn: () => authedOfetch('/financial-review')
    }); */
  const [prompts, setPrompts] = useState<
    {
      prompts?: {
    [x: string]: {
        title: string;
        prompt: {
            content: string;
            role: string;
        };
    };
}
    }
  >({})

  useEffect(() => {
    const proFn = async () => {
      const promptsRes = await TZAApiClient.internalAdmin(
        { authedRequestFn }
      );
      setPrompts({prompts: promptsRes});
    };
    proFn();
  }, [])

  const [checks, setChecks] = useState<boolean[]>([false, false, false]);

  const copyTextToClipboard = async (text, idx) => {
    await navigator.clipboard.writeText(text);
    checks[idx] = true;
    setChecks([...checks]);
  }

  const promptsEle = prompts.prompts ? (
    <Accordion overflow="hidden" type="single" defaultValue={'a0'}  style={{width: '100%'}}>
      {Object.values(prompts.prompts).map((obj, idx) => {
        return <Accordion.Item value={"a"+idx} key={idx}>
        <AccordionTrigger title={obj.title} />
        <Accordion.HeightAnimator transition="medium">
          <Accordion.Content transition="medium" exitStyle={{ opacity: 0 }} style={{maxHeight: 400, overflow: 'scroll'}}>
            <Button 
              margin="auto" 
              
              fontWeight={600}
              color={'black' /* color.tzaGreen */}
              //hoverStyle={{backgroundColor: color.tzaGreen, color: 'white', borderWidth: 1, borderColor: color.tzaGreen}}
              maxWidth={400}
              onPress={() => copyTextToClipboard(obj.prompt.content, idx)}
              icon={checks[idx] ? <CopyCheck color={color.tzaGreen} /> : <Copy />}
            >
              Copy to Clipboard
            </Button>
            <Paragraph style={{width: '100%', whiteSpace: 'pre-wrap'}}>{obj.prompt.content}</Paragraph>
          </Accordion.Content>
        </Accordion.HeightAnimator>
      </Accordion.Item>
      })}
    </Accordion>
  ) : (
    <Spinner size="large" color="$green10" />
  )
  return (
    <YStack f={1} justifyContent="center" alignItems="center" p="$4" space height={height - 90}  style={{width: '100%'}}>
      <YStack space="$4" bc="$background">
        {/* <H1 ta="center">The Zillennial Advisor</H1> */}
        <H2 ta="center">Prompts</H2>
      </YStack>
      {promptsEle}
      
    </YStack>
  )
}
